module.exports = __webpack_public_path__ + "static/media/success-icon.a96b7c1e.svg";